import FilterAPI from "../../api/FilterAPI";

const useCloudSearch = () => {
  const cloudSearchAction = ({
    searchedValue,
    moduleFilters,
    pagination,
  }: {
    searchedValue: any;
    moduleFilters: any;
    pagination: any;
  }) => {
    const data = FilterAPI.cloudSearch({
      searchedValue,
      moduleFilters,
      pagination,
    });
    return data;
  };
  return {
    cloudSearchAction: cloudSearchAction,
  };
};

export default useCloudSearch;
